import { render, staticRenderFns } from "./buyerOrderStat.vue?vue&type=template&id=1298ba4c&scoped=true&"
import script from "./buyerOrderStat.vue?vue&type=script&lang=js&"
export * from "./buyerOrderStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298ba4c",
  null
  
)

export default component.exports